import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  sideModal: {
    minWidth: '23rem'
  },

  filter: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 0.5rem 0 1rem',
    height: '100%',
    cursor: 'pointer',
    userSelect: 'none',

    [theme.breakpoints.down('md')]: {
      margin: '0 0.5rem 0 0.65rem'
    },

    '& .icon': {
      marginRight: '0.25rem',
      fontSize: theme.size.sm,
      color: theme.palette.primary.main,

      '& svg': {
        display: 'block'
      }
    },

    '& .text': {
      fontSize: theme.size.sm,
      color: theme.palette.textLight
    }
  },

  button: {
    fontSize: `${theme.size.sm} !important`,
    width: 'auto !important',
    padding: '5px 12px'
  },

  buttonSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '1rem 0'
  }
}))

export default useStyles
